export const storeGibAirRate = (state, gibAirRate) => {
  state.gibAirRate = { ...gibAirRate };
};
